module.exports = vendor_8e68c39dde1a0540d254;